import React, {useState, useEffect} from "react";
import Button from "../../common/Button";
import Logo from "../../../assets/logo.svg";
import Shadow from "../../../assets/shadows/6.png";

const Header = () => {

  const [menu, showMenu] = useState(false);
  
  const routes = [
    { id: "home", path: "/#home", label: "Home" },
    { id: "about", path: "/#about", label: "About" },
    { id: "competition", path: "/#competition", label: "Competition" },
    { id: "timeline", path: "/#timeline", label: "Timeline" },
    { id: "faq", path: "/#faq", label: "FAQ" },
  ];

  useEffect(() => {
    if(menu){
      document.body.style.overflow = "hidden";
    }else {
      document.body.style.overflow = "auto";
    }
  }, [menu]);

  const moveToSection = (path) => {
    showMenu(false);
    window.location.replace(path);
  }

  return (<>
    <div className=" relative z-20 w-full">
      <img src={Shadow} className="absolute top-0 z-10 right-0 sm:max-w-container max-w-[90vw] select-none" />
      <div className="sm:max-w-container max-w-[90vw] mx-auto z-20 relative flex justify-between gap-8 items-center py-10">
        <img src={Logo} className="opacity-100" alt="logo" />
        <ul className="md:flex hidden lg:gap-14 md:w-full lg:justify-center justify-around">
          {routes.map((route) => (
            <li
              key={route.id}
              className={`font-medium text-base cursor-pointer hover:text-warning hover:opacity-100 text-dark opacity-40`}
              onClick={() => moveToSection(route.path)}
            >
              {route.label}
            </li>
          ))}
        </ul>
        <Button className="md:block hidden whitespace-nowrap" onClick={() => window.open("https://discord.com/invite/KJwApgXs4s", "_blank")}>Join Discord</Button>
        <div className=" md:hidden flex flex-col gap-2 cursor-pointer" onClick={() => showMenu(!menu)}>
          <div className={" h-1 w-8 m-0 p-0 bg-black smooth" + (menu ? " rotate-45 " : " ")}></div>
          <div className={" h-1 w-8 m-0 p-0 bg-black smooth" + (menu ? " -rotate-45 -translate-y-3" : " ")}></div>
        </div>        
      </div>
      <div className={" w-full bg-[#F5F5F5] relative flex flex-col justify-around items-center md:h-0 md:overflow-hidden md:pb-0 smooth " +
         (menu ? " h-[calc(100vh-125px)] pb-40 opacity-100 " : " opacity-0 h-0 overflow-hidden")} >
          {routes.map((route) => (
            <div
              key={route.id + "_Link"}
              className={`relative z-50 font-medium text-2xl mx-[18px] cursor-pointer hover:text-warning hover:opacity-100 text-dark opacity-60`}
              onClick={() => moveToSection(route.path)}
            >
              {route.label}
            </div>
          ))}
      </div>
    </div>
    </>
  );
};

export default Header;
